import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';

export default function TopUp(props) {

     const settingData = useSelector(state => state.settingData);

    return (
        <Stack
            onClick={() => {
                window.open('https://payment.aplus-games.com/paymentList?gameId=mirren');
            }}
            sx={{
                display: JSTool.isCR() ? 'none' : 'flex',
                zIndex: 2,
                mx: 2,
                cursor: 'pointer',
                transitionDuration: '0.3s',
                fontFamily: window.MyFont,

                position: settingData.isMobile ? 'absolute' : 'block',
                right: settingData.isMobile && 0,
                top: settingData.isMobile && '90rem',

                '&:hover': {
                    transform: 'scale(1.07)',
                }
            }}>
            <Typography sx={{
                textAlign: 'center',
                color: 'white',
                fontSize: '18rem',
                fontFamily: window.font0,
            }}>
                Top-Up
            </Typography>

            <Typography sx={{
                textAlign: 'center',
                color: 'black',
                fontSize: '13rem',
                fontFamily: window.font0,
                backgroundSize: '100% 100%',
                backgroundImage: `url(${JSTool.getImgPath('nav_discount.png')})`,
                px: 3,
            }}>
                Discount
            </Typography>
        </Stack>
    );
}